import { createSlice } from "@reduxjs/toolkit";
import { BulkUploadType } from "../types/bulkUploadType";

const INIT_STATE: BulkUploadType = {
  showBulkAssignModal: false
};

export const BulkUploadSlice = createSlice({
  name: "BulkUploadSlice",
  initialState: INIT_STATE,
  reducers: {
    setShowModal(state, action) {
      state.showBulkAssignModal = action.payload;
    }
  }
});

export default BulkUploadSlice;
export const BulkUploadSliceActions = BulkUploadSlice.actions;
